const lessonFields = [
  {
    name: "title",
    label: "Lesson Title",
    type: "text",
    placeholder: "Type Lesson Title",
  },
  {
    name: "course_id",
    label: "Course Title",
    type: "text",
    placeholder: "Course Title",
  },
  {
    name: "description",
    label: "Lesson Description",
    type: "textarea",
    placeholder: "Lesson Description",
  },
  {
    name: "duration_in_minutes",
    label: "Lesson Duration",
    type: "number",
    placeholder: "Duration In Minutes",
  },
  {
    name: "status",
    label: "Lesson Status",
    type: "toggle",
    placeholder: "Select Lesson Status",
  },
];

export default lessonFields;
